export default __webpack_public_path__ + "static/1_1-a59ae16bc4e154af85cbf4d39dbc86a5.png";